import { actionCreator } from 'utils/redux';
export const NetActions = {
    connect: actionCreator('NET_CONNECT'),
    disconnect: actionCreator('NET_DISCONNECT')
};
